import React, { useState } from 'react';
import SafeIcon from '../../../common/SafeIcon';

const AdminSettings = () => {
  const [activeTab, setActiveTab] = useState('platform');

  const tabs = [
    { id: 'platform', name: 'Platform Settings', icon: 'Settings' },
    { id: 'notifications', name: 'Email Notifications', icon: 'Bell' },
    { id: 'users', name: 'User Management', icon: 'Users' },
    { id: 'audit', name: 'Audit Log', icon: 'Activity' }
  ];

  return (
    <div className="max-w-5xl mx-auto">
      <header className="mb-8">
        <h1 className="text-3xl font-serif font-bold text-navy-900">System Settings</h1>
        <p className="text-slate-500 mt-2">Manage global portal configurations and access.</p>
      </header>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col md:flex-row min-h-[500px]">
        {/* Sidebar Tabs */}
        <div className="w-full md:w-64 bg-slate-50 border-r border-slate-200 p-4">
          <nav className="space-y-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  activeTab === tab.id 
                    ? 'bg-navy-900 text-white' 
                    : 'text-slate-600 hover:bg-slate-200'
                }`}
              >
                <SafeIcon name={tab.icon} className="w-4 h-4" />
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* Content Area */}
        <div className="flex-1 p-8">
          {activeTab === 'platform' && (
            <div className="space-y-6 max-w-lg">
              <h2 className="text-xl font-bold text-navy-900 mb-6">Platform Settings</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-bold text-navy-900 mb-1">Platform Name</label>
                  <input type="text" defaultValue="The Kajidori Portal" className="w-full px-4 py-2 border border-slate-200 rounded-lg outline-none focus:border-navy-900" />
                </div>
                <div>
                  <label className="block text-sm font-bold text-navy-900 mb-1">Administrator Email</label>
                  <input type="email" defaultValue="admin@kajidoricollective.com" className="w-full px-4 py-2 border border-slate-200 rounded-lg outline-none focus:border-navy-900" />
                </div>
                <div>
                  <label className="block text-sm font-bold text-navy-900 mb-1">Default Session Duration (Hours)</label>
                  <input type="number" defaultValue="8" className="w-full px-4 py-2 border border-slate-200 rounded-lg outline-none focus:border-navy-900" />
                </div>
              </div>
              
              <button className="bg-navy-900 text-white px-6 py-2.5 rounded-lg font-bold hover:bg-navy-800 transition-colors mt-4">
                Save Changes
              </button>
            </div>
          )}

          {activeTab === 'notifications' && (
            <div className="space-y-6">
              <h2 className="text-xl font-bold text-navy-900 mb-6">Email Notifications</h2>
              
              <div className="space-y-4 divide-y divide-slate-100">
                {[
                  "Send email to participant when checked in",
                  "Send email to participant when certificate is issued",
                  "Send weekly compliance summary to managers",
                  "Send new application notification to administrator"
                ].map((text, i) => (
                  <div key={i} className="flex items-center justify-between py-3">
                    <span className="text-sm text-slate-700 font-medium">{text}</span>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" defaultChecked />
                      <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-navy-900"></div>
                    </label>
                  </div>
                ))}
              </div>
              
              <button className="bg-navy-900 text-white px-6 py-2.5 rounded-lg font-bold hover:bg-navy-800 transition-colors mt-6">
                Save Preferences
              </button>
            </div>
          )}

          {(activeTab === 'users' || activeTab === 'audit') && (
            <div className="flex flex-col items-center justify-center h-full text-center text-slate-500 py-12">
              <SafeIcon name={activeTab === 'users' ? 'Users' : 'Activity'} className="w-12 h-12 mb-4 text-slate-300" />
              <h3 className="text-lg font-bold text-navy-900 mb-2">Advanced Table Module</h3>
              <p className="max-w-sm">This section connects directly to the Supabase admin API for live data management.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;